import React from 'react';

export const DeleteIcon = props =>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="15"
    viewBox="0 0 13 15"
    style={{
      fillRule: 'evenodd',
    }}
    {...props}
  >
    <path
      d="M526,537v9a2,2,0,0,1-2,2h-7a2,2,0,0,1-2-2v-9a1,1,0,0,1,0-2h3v-2h5v2h3A1,1,0,0,1,526,537Zm-4-3h-3v1h3v-1Zm-4.5,4a0.5,0.5,0,0,1,.5.5v6a0.5,0.5,0,0,1-1,0v-6A0.5,0.5,0,0,1,517.5,538Zm3,0a0.5,0.5,0,0,1,.5.5v6a0.5,0.5,0,0,1-1,0v-6A0.5,0.5,0,0,1,520.5,538Zm3,0a0.5,0.5,0,0,1,.5.5v6a0.5,0.5,0,0,1-1,0v-6A0.5,0.5,0,0,1,523.5,538Z"
      transform="translate(-514 -533)"
    />
  </svg>;



// WEBPACK FOOTER //
// ./app/components/icons/delete-icon.js